import { IsReadOnlyContext } from "../../../website/components/IsReadOnlyContext";
import { CommentSection } from "../../../website/components/holiday-website/CommentSection";
import React from "react";

const DisplayCommentSection: React.FC = () => {
  const isReadOnly = React.useContext(IsReadOnlyContext);

  return (
    <div>
      <CommentSection isReadOnly={isReadOnly} />
    </div>
  );
};

export { DisplayCommentSection };
